{
  "pageTitle": "Suppliers panel",
  "pageSubtitle": "Manage suppliers",
  "search": {
    "placeholder": "Search by name..."
  },
  "table": {
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "isInternal": "Internal",
    "mediaUnitCount": "Media units",
    "actions": ""
  },
  "actions": {
    "addSupplier": "Add supplier",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving...",
    "saved": "Saved",
    "saveFailed": "Failed to save supplier",
    "deleted": "Supplier has been deleted"
  },
  "dialog": {
    "createTitle": "New supplier",
    "editTitle": "Edit supplier",
    "close": "Close",
    "fields": {
      "name": "Name",
      "nameRequired": "Name is required",
      "namePlaceholder": "Supplier name",
      "nameTaken": "A supplier with this name already exists",
      "email": "Email",
      "emailPlaceholder": "contact@supplier.com",
      "phone": "Phone",
      "phonePlaceholder": "+1...",
      "shippingAddress": "Shipping address",
      "shippingAddressPlaceholder": "Address for shipping materials to the supplier"
    },
    "suggestions": {
      "heading": "Existing supplier",
      "noResults": "No results"
    }
  },
  "deleteDialog": {
    "titleSimple": "Delete supplier",
    "titleWithUnits": "Delete supplier ({{count}} media units)",
    "descriptionSimple": "This action is irreversible.",
    "descriptionWithUnits": "This supplier has media units assigned. Choose what to do with them.",
    "strategyAriaLabel": "Choose deletion strategy",
    "strategyDeleteUnits": "Delete media units",
    "strategyReassign": "Move to another supplier",
    "targetSupplier": "Target supplier",
    "targetSupplierPlaceholder": "Select supplier...",
    "targetSupplierSearchPlaceholder": "Search supplier...",
    "targetSupplierNoResults": "No results",
    "confirmDelete": "Delete"
  },
  "errors": {
    "supplierNumberCollision": "Media unit number collision while moving.",
    "hasActiveReservations": "Cannot delete: media unit has an active reservation.",
    "missingStrategy": "Choose a deletion strategy."
  },
  "permissionDenied": "You don't have permission to access this page.",
  "empty": {
    "title": "No suppliers",
    "description": "Add your first supplier.",
    "descriptionPermissionScope": "A permission scope may be limiting what you can see."
  }
}
